import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'materialTransport';

const materialTransportService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      formData: true,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      formData: true,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  updateOrder: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/updateOrder`,
      data,
    });
  },
};
export default materialTransportService;
